const cache: { [lang: string]: string } = {}

export const getLanguageName = (langCode: string) => {
  if (!(langCode in cache)) {
    const names = new Intl.DisplayNames([langCode], { type: 'language' })
    const name = names.of(langCode) || ''
    cache[langCode] = name[0].toUpperCase() + name.substring(1)
  }

  return cache[langCode]
}
